export const VAPID_KEY="BAhBwfDunwzpIVTaBvCweZlFMEH5eNEs7afwQUt5GiDehOAuzIvubhFxeBZb6YplCt-_XESgI-hbfKHerty3Cpk";
export const WEB_PUSH_PROPOSAL_TIME= 7 * 24 * 60 * 60 * 1000;
